export default __webpack_public_path__ + "static/media/aveda-logo.112aeb9b.svg";